<template>
  <div>
    <!-- TODO: Replace with common loading dialog -->
    <v-dialog v-model="loading" hide-overlay persistent width="300">
      <v-card color="primary">
        <v-card-text>
          {{ $t('Loading') }}...
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-layout row wrap justify-space-between>
      <v-flex xs12 pa-2>
        <div class="headline">{{ $t('Archive') }}</div>
        <div class="body-1">{{ $t('Data is available per week') }}</div>
        <v-divider></v-divider>
      </v-flex>
      <v-flex xs12>
        <v-expansion-panel v-model="expansionState" class="primary">
          <v-expansion-panel-content v-for="(item, i) in devices" :key="i">
            <template v-slot:header>
              <div>{{ $t(item) }}</div>
            </template>
            <Card>
              <Toolbar>
                <v-toolbar-title>{{ $t('Archive Content') }}</v-toolbar-title>
              </Toolbar>
              <v-data-table :headers="headers" :items="items"
                :rows-per-page-items="[10, 20, 50, -1]"
                :rows-per-page-text="$t('Rows per page:')"
                class="elevation-1 primary">
                <template v-slot:items="props">
                  <tr class="primary">
                    <td>{{ props.item.name }}</td>
                    <td>{{ props.item.dateFrom }}</td>
                    <td>{{ props.item.dateTo }}</td>
                    <td class="text-xs-center">
                      <v-icon small @click="downloadReports(props.item, item)">
                        get_app
                      </v-icon>
                    </td>
                  </tr>
                </template>
                <template v-slot:no-data>
                  <v-btn color="primary" @click="initialize">{{ $t('Reset') }}</v-btn>
                </template>
              </v-data-table>
            </Card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import HeaderComponent from "../components/home/HeaderComponent";
import athenReportService from "../services/athena-reports.js";
import CommonApi from "@/services/Common";
import { mapGetters, mapMutations } from "vuex";

const momentTz = require('moment-timezone')

export default {
  data() {
    return {
      expansionState: 0,
      devices: [],
      loading: false
    };
  },
  computed: {
    ...mapGetters([
      'getSelectedPlantId',
      'getGeneralState',
      'getActivePlantInfo'
    ]),
    headers() {
      return [
        {
          text: this.$t("File"),
          align: "left",
          sortable: false,
          value: "name"
        },
        {
          text: this.$t("Date From"),
          align: "left",
          sortable: false,
          value: "dateFrom"
        },
        {
          text: this.$t("Date To"),
          align: "left",
          sortable: false,
          value: "dateFrom"
        },
        { text: this.$t("Actions"), value: "name", align: "center", sortable: false }
      ]
    },
    items () {
      let date = this.getActivePlantInfo('commission_date')
      let tz = this.getActivePlantInfo('timezone')
      let commissionDate = momentTz(date).tz(tz).isValid() ? momentTz(date).tz(tz) : momentTz("2018-01-01").tz(tz)

      const currentDate = momentTz().tz(tz).subtract(97, "day");
      const list = [];
      let flag = 0;
      while (commissionDate.isSameOrBefore(currentDate)) {
        const fromObj = momentTz(commissionDate).tz(tz);
        const toObj = momentTz(commissionDate).tz(tz);
        let dateFrom = flag
          ? fromObj
              .week(fromObj.week())
              .add(1, "day")
              .format("YYYY-MM-DD")
          : fromObj.week(fromObj.week()).format("YYYY-MM-DD");
        let dateTo = toObj.week(toObj.week() + 1).format("YYYY-MM-DD");
        list.push({
          name:
            commissionDate.format("YYYY, MMM") +
            " week " +
            commissionDate.format("ww"),
          dateFrom,
          dateTo
        });
        commissionDate = commissionDate.add(1, "week");
        flag = 1;
      }
      return list.reverse();
    }
  },
  components: {
    HeaderComponent
  },
  async mounted() {
    this.loading = true
    let response = await CommonApi.getDeviceList(this.getSelectedPlantId)
    this.loading = false
    this.devices = response.data.message
  },
  methods: {
    ...mapMutations(['SET_PROGRESS_BAR','SET_SHOW_SNACKBAR','SET_SNACKBAR_CONTENT']),
    downloadReports(item, device) {
      this.SET_PROGRESS_BAR(true)
      athenReportService
        .reportDownload({
          plantId: this.getSelectedPlantId,
          dateFrom: item.dateFrom,
          dateTo: item.dateTo,
          device: device
        })
        .then(res => {
          this.SET_PROGRESS_BAR(false)
          const downloadUrl = res.data.result;
      
          if (downloadUrl && typeof downloadUrl === 'string' && downloadUrl.length > 0) {
            let filename = `${device}_${item.dateFrom}_${item.dateTo}.csv`;

            try {
              const url = new URL(downloadUrl);
              const disposition = url.searchParams.get('response-content-disposition');
              
              if (disposition) {
                const match = disposition.match(/filename\s*=\s*"?(.+?)"?$/i); 
                if (match && match[1]) {
                  filename = decodeURIComponent(match[1].replace(/['"]/g, ''));
                }
              }
            } catch (e) {
              console.warn('Could not parse filename from URL query string:', e);
            }

            const link = document.createElement('a');
            link.href = downloadUrl;
            
            link.setAttribute('download', filename); 
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          } else {
            let payload = {
              icon: 'error',
              header: '', 
              message: 'No File To Download'
            }
            this.SET_SNACKBAR_CONTENT(payload)
            this.SET_SHOW_SNACKBAR(true)
          }
        })
        .catch(err => {
          console.error(err, 'Error')
        });
    },
    async getDevice() {
      this.loading = true;
      let response = await CommonApi.getDeviceList(this.getSelectedPlantId);
      this.loading = false;
      this.devices = response.data.message;
    }
  },
  watch: {
    getSelectedPlantId() {
      this.getDevice();
    }
  }
};
</script>
<style scoped>
.theme--dark.v-expansion-panel .v-expansion-panel__container {
  background-color: #2a335a;
}
</style>
